module.exports = __webpack_public_path__ + "joy-static/media/internet-speed-sled.ce5fa2f3.png";